import { find } from "lodash-es";
export default {
  data() {
    return {
      basicTimingOptions: [
        {
          value: 180,
          label: "3 minutes"
        },
        {
          value: 300,
          label: "5 minutes"
        },
        {
          value: 600,
          label: "10 minutes"
        },
        {
          value: 900,
          label: "15 minutes"
        },
        {
          value: 1200,
          label: "20 minutes"
        },
        {
          value: 1800,
          label: "30 minutes"
        },
        {
          value: 3600,
          label: "1 hour"
        },
        {
          value: 7200,
          label: "2 hours"
        },
        {
          value: 14400,
          label: "4 hours"
        },
        {
          value: 21600,
          label: "6 hours"
        },
        {
          value: 43200,
          label: "12 hours"
        },
        {
          value: 86400,
          label: "1 day"
        },
        {
          value: 172800,
          label: "2 days"
        },
        {
          value: 259200,
          label: "3 days"
        },
        {
          value: 345600,
          label: "4 days"
        },
        {
          value: 604800,
          label: "7 days"
        },
        {
          value: 864000,
          label: "10 days"
        },
        {
          value: 1296000,
          label: "15 days"
        }
      ],
      welcomeNotificationTiming: [],
      abandonedCartTiming: []
    };
  },
  created() {
    this.welcomeNotificationTiming = [
      {
        value: 0,
        label: "0 minutes"
      },
      ...this.basicTimingOptions
    ];
    this.abandonedCartTiming = [
      ...this.basicTimingOptions,
      {
        value: 2592000,
        label: "30 days"
      }
    ];
  },
  methods: {
    getLabelForValue(value, arr) {
      const item = find(arr, { value });
      return item.label;
    }
  }
};
